package com.cybersoftsolution.cybersoftsolutionweb.components.posts

import androidx.compose.runtime.Composable
import com.cybersoftsolution.cybersoftsolutionweb.components.text.MySpanText
import com.cybersoftsolution.cybersoftsolutionweb.models.SimplePost
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.styles.MyCheckBoxStyle
import com.cybersoftsolution.cybersoftsolutionweb.utils.Utils.toStringDateTime
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextOverflow
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textOverflow
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px

@Composable
fun PostPreview(
    simplePost: SimplePost,
    selectable: Boolean = false,
    setSelectPost: (Boolean) -> Unit
) {
    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.SpaceBetween,
        modifier = MyCheckBoxStyle.toModifier()
            .borderRadius(12.px)
            .backgroundColor(if (!simplePost.selected) {Theme.LightGray.rgb} else {Theme.LightBlue.rgb})
            .margin(8.px)
            .padding(8.px)
            .transition(
                Transition.of(
                    property = "background-color",
                    duration = 300.ms,
                    timingFunction = null,
                    delay = null
                )
            )

            .thenIf(
                condition = simplePost.selected,
                other = Modifier
                    .border(
                    width = 2.px,
                    style = LineStyle.Solid,
                    color = Theme.Primary.rgb
                    )
            )
            .thenIf(
                selectable,
                Modifier
                    .cursor(Cursor.Pointer)
                    .onClick {
                    setSelectPost(!simplePost.selected)
                    }
            )
    ) {

        Column(
            horizontalAlignment = Alignment.Start,
            verticalArrangement = Arrangement.Top,
            modifier = Modifier
                .margin(if (!simplePost.selected) {8.px} else {6.px})
                .padding(if (!simplePost.selected) {8.px} else {6.px})
                .transition(
                    Transition.of(
                        property = "margin",
                        duration = 300.ms,
                        timingFunction = null,
                        delay = null
                    )
                )
                .transition(
                    Transition.of(
                        property = "padding",
                        duration = 300.ms,
                        timingFunction = null,
                        delay = null
                    )
                )

        ) {
            SpanText(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(bottom = 8.px)
                    .fontSize(12.px)
                    .color(Theme.HalfBlack.rgb)
                    .textOverflow(TextOverflow.Ellipsis)
                    .overflow(Overflow.Hidden)
                    .styleModifier {
                        property("display", "-webkit-box")
                        property("-webkit-line-clamp", "2")
                        property("line-clamp", "2")
                        property("-webkit-box-orient", "vertical")

                    }
                ,

                text = simplePost.date.toStringDateTime()
            )
            Image(
                src = simplePost.image.orEmpty(),
                modifier = Modifier
                    .fillMaxWidth()
//                    .height(350.px)
                    .objectFit(ObjectFit.Cover)
                    .padding(bottom = 16.px)
            )
            MySpanText(
                text = simplePost.title,
                maxLines = 2,
                fontSize = 20,
                modifier = Modifier
                    .fillMaxWidth()
                    .fontFamily("serif")
                    .padding(bottom = 8.px),

            )
            MySpanText(
                text = simplePost.subtitle,
                maxLines = 3,
                fontSize = 15,
                modifier = Modifier
                    .fillMaxWidth()
                    .fontFamily("serif")
                    .padding(bottom = 8.px),

                )

        }


        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(8.px)
                .margin(8.px)
            ,
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {

            Box(
                contentAlignment = Alignment.Center,
                modifier = Modifier
                    .backgroundColor(Colors.Transparent)
                    .borderRadius(25.px)
                    .border(
                        width = 1.px,
                        style = LineStyle.Groove,
                        color = Color(simplePost.category?.color?: Theme.Transparent.hex)
                    )

            ) {
                MySpanText(
                    text = simplePost.category?.name,
                    maxLines = 1,
                    fontSize = 14,
                    modifier = Modifier
                        .padding(topBottom = 4.px, leftRight = 12.px)
                        .margin(leftRight = 4.px)
                        .fontFamily("FONT_FAMILY")

                    )


            }
            Box(
                contentAlignment = Alignment.Center,
                modifier = Modifier
                    .backgroundColor(Colors.Transparent)
                    .borderRadius(25.px)
                    .border(
                        width = 1.px,
                        style = LineStyle.Solid,
                        color = Color(Theme.HalfBlack.hex)
                    )

            ) {

                MySpanText(
                    text = simplePost.userName,
                    maxLines = 1,
                    fontSize = 14,
                    modifier = Modifier
                        .padding(topBottom = 4.px, leftRight = 12.px)
                        .margin(leftRight = 4.px)
                        .fontFamily("FONT_FAMILY")

                )

            }


        }




    }
}